// src/components/InstagramFeed.js
import React, { useEffect } from 'react';
import './InstagramFeed.css';

const InstagramFeed = () => {
  useEffect(() => {
    /* ------------------------------------------------------------------
     * 1.  Hide and remove the POWR watermark element (.js-powrMark).
     * ------------------------------------------------------------------ */
    const styleTag = document.createElement('style');
    styleTag.textContent = '.js-powrMark{display:none !important}';
    document.head.appendChild(styleTag);

    // Delete any watermark nodes already present
    const purgeMarks = (root = document) =>
      root.querySelectorAll('.js-powrMark').forEach(el => el.remove());
    purgeMarks();

    // Observe future DOM changes so late-injected marks are removed
    const observer = new MutationObserver(mutations =>
      mutations.forEach(({ addedNodes }) =>
        addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;               // not an element
          if (node.classList.contains('js-powrMark')) {
            node.remove();
          } else {
            purgeMarks(node);                            // check subtree
          }
        })
      )
    );
    observer.observe(document.body, { childList: true, subtree: true });

    /* ------------------------------------------------------------------
     * 2.  Load the POWR Instagram Feed script (only once).
     * ------------------------------------------------------------------ */
    if (!document.querySelector('script[src*="powr.io/powr.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://www.powr.io/powr.js?platform=react';
      script.async = true;
      document.body.appendChild(script);
    }

    /* ------------------------------------------------------------------
     * 3.  Clean-up when the component unmounts.
     * ------------------------------------------------------------------ */
    return () => {
      observer.disconnect();
      if (document.head.contains(styleTag)) {
        document.head.removeChild(styleTag);
      }
    };
  }, []);

  return (
    <div className="instagram-feed-container">
      <div
        className="powr-instagram-feed"
        id="refounded-instagram-feed"
        /* POWR configuration attributes */
        data-account="@refoundeducation"
        data-items-to-show="8"
        data-show-feed-header="true"
        data-show-user-information="true"
        data-show-load-more="false"
        data-show-timestamps="true"
        data-grid-columns="4"
        data-layout="grid"
        data-show-captions="hover"
        data-display-profile-info="name"
      ></div>
    </div>
  );
};

export default InstagramFeed;
